// extracted by mini-css-extract-plugin
export default {"productGallery":"pI-z","inQuickShop":"qI-z"};